import { render, staticRenderFns } from "./SearchUsers.vue?vue&type=template&id=4afab17f&"
import script from "./SearchUsers.vue?vue&type=script&lang=js&"
export * from "./SearchUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports